import React, { observer } from 'mobx-react'
import { createContext, ReactElement, useContext, useRef } from 'react'

import UserAttendanceUIStore from '../stores/UserAttendanceUIStore/UserAttendanceUIStore'

interface Props {
   children: ReactElement
}

export const UserAttendanceUIStoreContext = createContext<UserAttendanceUIStore | null>(
   null
)

const useUserAttendanceUIStore = (): UserAttendanceUIStore => {
   const context = useContext(UserAttendanceUIStoreContext)

   if (!context) {
      throw new Error(
         'Expected to be wrapped in UserAttendanceUIStore Provider'
      )
   }

   return context
}

const UserAttendanceUIStoreProvider = observer(
   (props: Props): ReactElement => {
      const userAttendanceUIStoreRef = useRef(
         UserAttendanceUIStore.createStore()
      )

      return (
         <UserAttendanceUIStoreContext.Provider
            value={userAttendanceUIStoreRef.current}
         >
            {props.children}
         </UserAttendanceUIStoreContext.Provider>
      )
   }
)

export { useUserAttendanceUIStore, UserAttendanceUIStoreProvider }
